module.exports = __webpack_public_path__ + "assets/img/26-s.77ebe9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/26-s.jpg
// module id = Ua1b
// module chunks = 0